import axios from 'axios';

import elements from './elements';
import state from './state';
import delay from './helpers/delay';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const action = '/news_subscribe/';

export const newsSubscription = () => {
  const { subscriptionForm } = elements;
  const { newsSubscriptionForm } = state;

  const successMessage = document.querySelector('[data-subscription-success-message]');
  const errorMessage = document.querySelector('[data-subscription-error-message]');

  const emailField = subscriptionForm.querySelector('[type="email"]');
  const submitButton = subscriptionForm.querySelector('[type="submit"]');

  emailField.addEventListener('input', (e) => {
    newsSubscriptionForm.fields.email = e.target.value;
    console.warn(state);
  });

  subscriptionForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    const { target } = e;
    const formData = new FormData(target);

    try {
      subscriptionForm.classList.add('is_loading');
      submitButton.disabled = true;
      await delay(1000);
      const res = await axios.post(action, formData);
      errorMessage.style.display = 'none';
      successMessage.style.display = 'block';
      target.reset();
    } catch (error) {
      successMessage.style.display = 'none';
      errorMessage.style.display = 'block';
      throw new Error(error);
    } finally {
      subscriptionForm.classList.remove('is_loading');
      submitButton.disabled = false;
    }
  });
};
